if (!customElements.get('tab-content')) {
  class TabContent extends HTMLElement {
    connectedCallback() {
      const navButtons = this.querySelectorAll('.tab-content__nav button');
      const contentPanels = this.querySelectorAll('.tab-content__content > div');
      navButtons.forEach(button => {
        button.addEventListener('click', () => {
          const targetId = button.getAttribute('aria-controls');
          navButtons.forEach(btn => btn.setAttribute('aria-selected', false));
          button.setAttribute('aria-selected', true);
          contentPanels.forEach(panel => panel.setAttribute('aria-hidden', true));
          document.getElementById(targetId).setAttribute('aria-hidden', false);
        });
      });
    }
  }
  
  customElements.define('tab-content', TabContent);
}
